var _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _circle4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 190,
    viewBox: "0 0 201 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 90,
    r: 90,
    fill: "#D9EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 57C47 43.7452 57.7452 33 71 33H144V148H71C57.7452 148 47 137.255 47 124V57Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 148C137 143 131 134.5 131 138C131 141.5 126 148 121 148H132Z",
    fill: "#A1CEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131 45C131 38.3726 136.373 33 143 33C149.627 33 155 38.3726 155 45V148H131V45Z",
    fill: "#A1CEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 45C131.5 38.6487 136.649 33.5 143 33.5C149.351 33.5 154.5 38.6487 154.5 45V147.25L131.5 137.667V45Z",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 177,
    r: 13,
    fill: "#3681D3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 98,
    r: 8,
    fill: "#3681D3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 19,
    r: 12,
    fill: "#3681D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132 133H165V148H132V133Z",
    fill: "#A1CEFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 56,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 56,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 68,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 68,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 80,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 80,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 92,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 92,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 104,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 104,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 116,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 116,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 128,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 128,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155 77H177V137C177 143.075 172.075 148 166 148C159.925 148 155 143.075 155 137V77Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 148H121C115 148 109.5 143 109.5 137.5V112H24V137.5C24 143 29 148 34 148Z",
    fill: "#A1CEFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121 148C115 148 109.5 143 109.5 137.5V112H24V137.5C24 143 29 148 34 148",
    stroke: "black",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 77V137C154.5 143.075 159.425 148 165.5 148V148",
    stroke: "black",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 77V137.5C131.5 143.299 126.799 148 121 148V148",
    stroke: "black",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.045 16.6858C188.577 16.9958 188.117 17.1822 187.665 17.2451C187.214 17.308 186.833 17.3021 186.524 17.2276C186.214 17.153 185.717 17.02 185.032 16.8286C184.961 16.8114 184.674 16.7223 184.17 16.5614C183.667 16.4004 183.162 16.3582 182.658 16.4347C182.144 16.4958 181.66 16.6765 181.207 16.9768C180.447 17.4805 179.976 18.1795 179.795 19.0738C179.59 19.9623 179.727 20.8075 180.204 21.6094C180.682 22.4114 181.361 22.9184 182.241 23.1306C183.098 23.3371 183.914 23.1836 184.688 22.6701L185.478 22.147L186.095 23.2864L185.349 23.7805C184.662 24.2358 183.928 24.475 183.147 24.4981C182.366 24.5212 181.631 24.3309 180.942 23.9272C180.238 23.5331 179.666 22.9659 179.226 22.2257C178.785 21.4854 178.546 20.708 178.51 19.8934C178.459 19.0886 178.61 18.3324 178.963 17.625C179.317 16.9176 179.83 16.3411 180.502 15.8955C181.072 15.5177 181.617 15.2857 182.136 15.1995C182.641 15.123 183.079 15.1229 183.451 15.1992C183.813 15.2601 184.313 15.3806 184.95 15.5605C185.069 15.5892 185.376 15.6763 185.87 15.8218C186.35 15.977 186.806 16.0406 187.237 16.0125C187.66 15.9691 188.061 15.8214 188.441 15.5695L189.516 14.8575L190.163 15.9447L189.045 16.6858ZM193.001 14.548C192.752 14.7127 192.492 14.7558 192.221 14.6773C191.936 14.6084 191.715 14.443 191.559 14.1808C191.403 13.9186 191.362 13.6446 191.436 13.3587C191.487 13.0671 191.637 12.8389 191.885 12.6742C192.134 12.5095 192.401 12.4616 192.686 12.5304C192.972 12.5992 193.188 12.757 193.335 13.0038C193.491 13.2659 193.536 13.5477 193.471 13.849C193.406 14.1503 193.249 14.3833 193.001 14.548Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.117 179.951C135.755 179.421 135.537 178.9 135.464 178.387C135.391 177.875 135.398 177.444 135.485 177.093C135.571 176.743 135.727 176.18 135.95 175.403C135.97 175.323 136.074 174.997 136.262 174.426C136.449 173.855 136.499 173.284 136.41 172.712C136.338 172.129 136.127 171.581 135.777 171.068C135.189 170.206 134.374 169.673 133.331 169.468C132.294 169.236 131.308 169.39 130.372 169.931C129.437 170.472 128.845 171.242 128.598 172.24C128.357 173.211 128.536 174.135 129.135 175.013L129.745 175.908L128.416 176.607L127.839 175.763C127.308 174.984 127.029 174.152 127.002 173.267C126.975 172.381 127.197 171.548 127.668 170.767C128.128 169.97 128.79 169.322 129.653 168.822C130.517 168.323 131.424 168.052 132.374 168.011C133.313 167.953 134.196 168.124 135.021 168.525C135.846 168.925 136.519 169.507 137.039 170.269C137.479 170.915 137.75 171.532 137.851 172.121C137.94 172.693 137.94 173.19 137.851 173.611C137.78 174.022 137.639 174.588 137.429 175.31C137.396 175.445 137.294 175.793 137.125 176.353C136.943 176.897 136.869 177.413 136.902 177.902C136.953 178.381 137.125 178.836 137.419 179.267L138.25 180.484L136.981 181.218L136.117 179.951ZM138.611 184.434C138.419 184.152 138.368 183.858 138.46 183.551C138.54 183.227 138.733 182.977 139.039 182.8C139.345 182.623 139.665 182.577 139.998 182.661C140.338 182.719 140.605 182.888 140.797 183.17C140.989 183.451 141.045 183.754 140.965 184.078C140.884 184.401 140.7 184.646 140.412 184.813C140.106 184.99 139.778 185.041 139.426 184.967C139.075 184.893 138.803 184.716 138.611 184.434Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01974 99.0476C7.19046 98.8414 7.37359 98.6958 7.56911 98.6109C7.76464 98.5259 7.93695 98.4828 8.08606 98.4814C8.23517 98.4801 8.47643 98.4843 8.80985 98.494C8.84426 98.4937 8.98537 98.502 9.23316 98.5189C9.48096 98.5358 9.7137 98.4953 9.93136 98.3974C10.1552 98.3058 10.3498 98.1601 10.5151 97.9604C10.7926 97.6253 10.9142 97.2309 10.8801 96.7771C10.8575 96.3232 10.6867 95.9315 10.3677 95.6018C10.0487 95.2722 9.67697 95.1093 9.25259 95.1132C8.83968 95.117 8.49184 95.2897 8.20907 95.6312L7.92097 95.9792L7.49529 95.5034L7.76738 95.1748C8.01814 94.8719 8.3181 94.6677 8.66726 94.5622C9.01643 94.4567 9.37239 94.4598 9.73515 94.5716C10.1032 94.6769 10.4345 94.8818 10.729 95.186C11.0234 95.4903 11.2316 95.837 11.3535 96.226C11.4807 96.6085 11.5104 96.992 11.4426 97.3763C11.3749 97.7606 11.2183 98.101 10.9728 98.3975C10.7648 98.6488 10.5492 98.8266 10.3262 98.931C10.1086 99.0289 9.91104 99.0819 9.73366 99.0899C9.56242 99.1043 9.32155 99.1065 9.01107 99.0965C8.95372 99.097 8.80421 99.092 8.56255 99.0814C8.32622 99.0644 8.11256 99.0887 7.92157 99.1544C7.73672 99.2265 7.57493 99.3463 7.43622 99.5138L7.04408 99.9875L6.61159 99.5406L7.01974 99.0476ZM5.51323 100.558C5.60393 100.448 5.71543 100.396 5.84773 100.401C5.98537 100.4 6.10633 100.453 6.21062 100.561C6.31491 100.669 6.36878 100.796 6.37224 100.943C6.38717 101.09 6.34928 101.219 6.25859 101.328C6.16789 101.438 6.05372 101.493 5.91608 101.494C5.77845 101.496 5.66055 101.445 5.5624 101.344C5.45811 101.236 5.40117 101.106 5.39158 100.952C5.38198 100.799 5.42254 100.667 5.51323 100.558Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPayment);
export default __webpack_public_path__ + "static/media/empty-payment.285941bda37bab065002488be38aef9d.svg";
export { ForwardRef as ReactComponent };